import { StationLabel } from '@app/modules/admin/screens/stations/list/StationLabel';
import { useStationsWithAudit } from '@app/modules/audit/hooks/useStationsWithAudit';

interface SavedReportsStationCellProps {
  stationId: string;
}

/**
 * Resolves a station id to a StationLabel for saved-reports table rows.
 */
export function SavedReportsStationCell({ stationId }: SavedReportsStationCellProps) {
  const stations = useStationsWithAudit();
  const station = stations.find((s) => s.id === stationId);

  if (!station) {
    return <>{stationId}</>;
  }

  return <StationLabel station={station} singleLineEllipsis />;
}
